module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm1"
    }
  }, [_c('p', {
    staticClass: "heading1"
  }, [_c('span', [_vm._v("PRAISE FOR")])]), _vm._v(" "), _c('p', {
    staticClass: "heading1a"
  }, [_c('span', [_c('i', [_vm._v("CODE NAME: GRAND GUIGNOL")])])]), _vm._v(" "), _c('p', [_vm._v("“One of the better suspense novels . . . high-flying . . . Melchior has plenty of authenticity to back up his theater troupe and the German superweapon, which also really existed.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_vm._v("— "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kirkus Reviews")])])]), _vm._v(" "), _c('p', [_vm._v("“A completely suspenseful novel which captivates from beginning to end. Absolutely first class reading. But take care: don’t begin the novel on an evening when you want to go to sleep early, for it is all but impossible to put the book aside once one has begun to read it!”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_vm._v("— Sven Rye, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Den Danske Pioneer")])])]), _vm._v(" "), _c('p', [_vm._v("“Fascinating . . . all in all, it is a fine book.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_vm._v("— "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mystery Scene")])])]), _vm._v(" "), _c('p', [_vm._v("“Melchior’s previous thrillers owe their authenticity to his experiences in the OSS during WWII. So does his new novel. The story ranks high in suspense, atmosphere and heartwarming moments as the band proves the value of the old adage: all for one, one for all . . . a fine entertainment.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_vm._v("— "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishers Weekly")])])]), _vm._v(" "), _c('p', [_vm._v("“There is plenty of blood spilled in CODE NAME: GRAND GUIGNOL which is based on a little-known Nazi scheme during World War II to develop a secret weapon that could destroy the Allied invasion operation. Melchior provides plenty of action and lots of gore.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_vm._v("— Orlando (FL) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sentinel")])])]), _vm._v(" "), _c('p', [_vm._v("“Grand Guignol was no ordinary theatre. It specialized in horror and blood-soaked realism . . . the name still lingers on as a synonym for horror fiction. (CODE NAME: GRAND GUIGNOL) is an ingenious novel.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_vm._v("— "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Barkham Reviews")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ef22fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Critical_praise.vue
// module id = 63
// module chunks = 0